import CLUSTER_SPEECH_BUBBLE from '../../presentation/assets/markers/CLUSTER-speech-bubble.svg';
import CLUSTER_SPEECH_BUBBLE_ORANGE from '../../presentation/assets/markers/CLUSTER-speech-bubble-orange.svg';

export const markerClustercOptions = {
  styles: [
    {
      url: CLUSTER_SPEECH_BUBBLE,
      height: 50,
      width: 150,
    },
  ],
};

export const markerClustercOptionsSchools = {
  styles: [
    {
      url: CLUSTER_SPEECH_BUBBLE_ORANGE,
      height: 50,
      width: 150,
    },
  ],
};

export const defaultStrokeStyle = {
  strokeColor: '#000',
  strokeOpacity: 1,
};

export const defaultFillStyle = {
  fillColor: '#000',
  fillOpacity: 0.35,
};

export const defaultMapCircleStyles = {
  ...defaultStrokeStyle,
  strokeWeight: 2,
  ...defaultFillStyle,
};

export const polygonStaticStyles = {
  strokeColor: '#000',
  strokeOpacity: 0.8,
  strokeWeight: 0.5,
  fillOpacity: 0.35,
};

export const polygonLine = {
  clickable: false,
  ...defaultStrokeStyle,
};

export const polygonFreeHandStyles = {
  ...defaultStrokeStyle,
  ...defaultFillStyle,
};
